import { LienPriorityType } from 'constants/loanApplication';

const LIEN_SUFFIX_SLICE_INDEX = -2;

export const deferredThreshold = 60;

export const LIEN_POSITION_MAP = Object.values(LienPriorityType).reduce((acc, value, index) => {
  acc[value] =
    value !== LienPriorityType.OTHER
      ? `${index + 1}${value.slice(LIEN_SUFFIX_SLICE_INDEX)}`
      : 'TBD';

  return acc;
}, {});

export const COLUMNS_SMALL_SCREEN = 3;
export const COLUMNS_LARGE_SCREEN = 4;
